import { OTPTransfer } from './OTPTransfer';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ibanTransferOTPCall, changeUserStatusCall } from 'actions/ibanActions';
import { hidePreLoader, showPreLoader } from 'actions/preLoaderActions';
import { enableFinishedAndNextStep, finalizeStep, changeCurrentStep, enablePreviousSteps } from 'actions/stepsActions';
import { actions } from 'react-redux-form';
const { change } = actions;

export const OTPTransferView = connect(
    state => ({
        errorState: state.error,
        userProfile: state.userProfile,
        immStepsState: state.steps,
        products: state.products,
    }),
    dispatch => ({
        ibanTransferOTPCall: bindActionCreators(ibanTransferOTPCall, dispatch),
        showPreLoader: bindActionCreators(showPreLoader, dispatch),
        hidePreLoader: bindActionCreators(hidePreLoader, dispatch),
        changeUserStatusCall: bindActionCreators(changeUserStatusCall, dispatch),
        enableFinishedAndNextStep: bindActionCreators(enableFinishedAndNextStep, dispatch),
        finalizeStep: bindActionCreators(finalizeStep, dispatch),
        changeCurrentStep: bindActionCreators(changeCurrentStep, dispatch),
        enablePreviousSteps: bindActionCreators(enablePreviousSteps, dispatch),
        change: bindActionCreators(change, dispatch),
    })
)(OTPTransfer);
